import React, { useEffect, useState } from "react";
import ObjectiveSelect from "../../../../common/CERGoalsForm/AddObjectiveForm/ObjectiveSelect";
import AddEntityForm from "../../../../common/CERGoalsForm/common/AddEntityForm";
import useAmendmentModule from "../../../hooks/useAmendmentModule";

const AddAmendmentObjectiveForm = ({ pathType }) => {
  const { events } = useAmendmentModule();

  const [newObjective, setNewObjective] = useState({
    goal: "",
    pathType: pathType.id,
    steps: [],
    updateType: "ADDED",
    detail: { status: "UNFINISH" },
  });

  const handleNewObjectiveChange = (e) => {
    const { name, value } = e.target;
    setNewObjective({ ...newObjective, [name]: value });
  };

  const handleAddObjective = () => {
    events.onAddObjective(newObjective);
    setNewObjective({
      goal: "",
      pathType: pathType.id,
      steps: [],
      updateType: "ADDED",
      detail: { status: "UNFINISH" },
    });
  };

  useEffect(() => {
    if (newObjective.goal) {
      handleAddObjective();
    }
  }, [newObjective]);

  return (
    <AddEntityForm onSubmit={handleAddObjective}>
      <div className="mt-2 d-flex">
        <ObjectiveSelect
          handleNewObjectiveChange={handleNewObjectiveChange}
          objective={newObjective}
          k={`addObj`}
        />
        {/* <div className="d-flex justify-content-end">
          <button className="btn btn-sm" type="submit" disabled={!newObjective.goal}>
            <i className="fa fa-plus" />
          </button>
        </div> */}
      </div>
    </AddEntityForm>
  );
};

export default AddAmendmentObjectiveForm;
